import { useNavigate } from 'react-router-dom';
import { NavigationRoutes } from '../router/routes.ts';
import { Button } from '@mui/material';

const NotFoundPage = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate(NavigationRoutes.login);
    };

    return (
        <div className="flex flex-col items-center justify-center h-screen">
            <h1 className="text-4xl font-bold mb-4">
                404 - Sidan hittades inte
            </h1>
            <p className="mb-4"></p>
            <Button
                type={'button'}
                onClick={handleGoHome}
                className="bg-blue-500 text-white px-4 py-2 rounded"
            >
                Go to Home
            </Button>
        </div>
    );
};

export default NotFoundPage;
